// Rights
export const READ = 'Read'; // FOR SELL SCREEN -> Read will be served as makeSales and perform the operation of read, create & update
export const CREATE = 'Create';
export const UPDATE = 'Update';
export const DELETE = 'Delete';

//Permissions

//Permission on Sell Screen
export const ShowProductCosts = "ShowProductCosts"; // also for product & reporting & stock controlApplyDiscounts
export const ApplyDiscounts = "ApplyDiscounts"; // Allow a Cashier to provide discounts on a sale, including individual line items. This excludes managing price books.
export const CreateOrContinueOnAccountSales = "CreateOrContinueOnAccountSales";
export const CreateOrContinueLaybySales = "CreateOrContinueLaybySales";
export const IssueManualStoreCredit = "IssueManualStoreCredit";
export const ReturnAndExchange = "ReturnAndExchange"; //Perform returns and exchanges from all outlets
export const IssueStoreCreditForReturnSale = "IssueStoreCreditForReturnSale"; //Issue store credit for a return sale
export const VoidSalesOnSalesHistory = "VoidSalesOnSalesHistory";
export const EditSalesOnSaleHistory = "EditSalesOnSaleHistory"
export const MakeSales = "MakeSales" // Right-> Read will be served as makeSales and perform the operation of read, create & update

//Permission on Stock Control
export const PrintLabels = "PrintLabels"

//Permission for sale tracking screen
export const PreparingScreen = "PreparingScreen"
export const ServingScreen = "ServingScreen"

//Permission for sale tracking screen
export const DashboardReport = "DashboardReport"
